import React from 'react'

import { FileMaganerSection } from '../../Common'
import { Box, Button } from '@mui/material'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'

export const FilesAttachmentStep = ({ useFetchInit }) => {

    const { 
        //------------- Generales
        // location,
        // paramsURL,
        //------------- globalStates
        globalStates,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions,
        //------------- helpers
        // Helpers,
        //------------- Formularios
        // Forms
        
    } = useFetchInit

    // ------------------------------------------------ Generales
        
    // ------------------------------------------------ globalStates
    const {formOpeningMode} = globalStates

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    
    // ------------------------------------------------ FetchData
    
    // ------------------------------------------------ Actions
    const {
        handleClickReturnStep,
        handleClickNextStep
    } = Actions

    return (
        <>
            <FileMaganerSection useFetchInit={useFetchInit} />
            <div className="pt-4"></div>
            <Box className="text-center" sx={{mt: 2}}>
                <Button 
                    startIcon={<ArrowLeftCircle/>}
                    variant="contained"
                    type="button"
                    onClick={handleClickReturnStep} 
                    sx={{ marginRight: 1, marginLeft: 1, background: "#ef8157" }}
                >
                    Volver
                </Button>

                {(formOpeningMode==='EDITABLE') && (
                    <Button
                        endIcon={<ArrowRightCircle/>}
                        variant="contained"
                        type='button'
                        onClick={handleClickNextStep}
                        style={{ marginRight: 2, marginLeft: 2, background: "#4b4b4c" }}
                    >
                        Continuar
                    </Button>
                )} 
            </Box>
        </>
        
    )
}
